import type { Dispatch, ReactNode, SetStateAction } from "react";
import { CreateActionButton } from "./CreateActionButton";
import { PrizesHeader } from "./PortalPrimitives";
import { ScreenToolbar } from "./ScreenToolbar";
import type { StatusFilterValue } from "./StatusFilterSelect";

// GATE-01-A (agent-logs/runs/2026-09-11-spec-219-offers/evidence/
// human-resolution-gate-01-dup-and-format.json): `PrizesHeader` seguido de
// `ScreenToolbar` era el mismo marcado palabra por palabra en
// benefits/BenefitsScreen.tsx, rewards/RewardsScreen.tsx y
// offers/OffersScreen.tsx (TABS-A/NAV-01: las tres comparten el encabezado y
// la fila de pestañas de "Gestión de Premios"), incluido el `onSearchChange`/
// `onStatusChange` que arma cada pantalla contra su propio `setFilter` — las
// tres hacen exactamente `setFilter((prev) => ({ ...prev, campo: valor }))`.
// Por eso este componente recibe `filter`/`setFilter` en vez de los
// manejadores ya armados: cada pantalla sigue siendo dueña de la forma de su
// `FilterState` (search/status son el único contrato compartido; el resto
// —`type`, `categoryId`— viaja intacto en `extraFilters`, que cada pantalla
// sigue componiendo). Las tres siempre usan `CreateActionButton` como única
// acción, de ahí `createLabel`/`onCreate` en vez de un `actions: ReactNode`
// genérico. Cada pantalla conserva su propio comentario de resolución
// humana justo encima del llamado. Extracción sin cambio de comportamiento
// ni de valores visuales: ninguna pantalla que la use cambia un pixel por
// esto.
export function PrizesScreenToolbar<
  F extends { search: string; status: StatusFilterValue },
>({
  filter,
  setFilter,
  searchPlaceholder,
  extraFilters,
  createLabel,
  onCreate,
}: {
  filter: F;
  setFilter: Dispatch<SetStateAction<F>>;
  searchPlaceholder: string;
  extraFilters?: ReactNode;
  createLabel: string;
  onCreate: () => void;
}) {
  return (
    <>
      <PrizesHeader />
      <ScreenToolbar
        searchValue={filter.search}
        onSearchChange={(event) =>
          setFilter((prev) => ({ ...prev, search: event.target.value }))
        }
        searchPlaceholder={searchPlaceholder}
        extraFilters={extraFilters}
        statusValue={filter.status}
        onStatusChange={(status) => setFilter((prev) => ({ ...prev, status }))}
        actions={<CreateActionButton label={createLabel} onClick={onCreate} />}
      />
    </>
  );
}
